import React, { useState, useEffect } from 'react'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { API_HOST } from '../../api_utils';
import axios from 'axios';
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from 'react-toastify'

function CNYCheck(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [cnnyList, setCnnyList] = useState([])
  const [cnnyDeleteSuccess, setCnnyDeleteSuccess] = useState(false)

  const getCnnyListApi = async () => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/cnny_start/`, config);
    if (data) {
      if (!data.message) {
        setCnnyList(data)
      } else {
        setCnnyList([])
      }
    }
  }

  useEffect(() => {
    getCnnyListApi()
  }, [cnnyDeleteSuccess, cnnyList])

  const deleteCnyHandler = async (cnyId) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.delete(`${API_HOST}/api/cnny_start/${cnyId}`, config);
    if (data) {
      if (!data.message) {
        setCnnyDeleteSuccess(true)
        toast.success('CNY Deleted Successfully !!!')
      } else {
        toast.error(data.message)
      }
    }
  }



  return (
    <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
      <p className='text-gray-800 text-[1.8rem] tracking-wider'>CNY Data</p>
      <div className='mt-8 '>
        <table className='w-[100%]'>
          <thead className='h-[6vh]'>
            <tr className=''>
              <th className='text-start'>CN NY Start</th>
              <th className='text-start'>CN NY Year</th>
              <th className='text-start'></th>
            </tr>
          </thead>
          <tbody>
            {
              cnnyList.length ? cnnyList.map((x, index) => {
                const date = new Date(x.cn_ny_start);
                const formattedDate = date.toLocaleDateString('en-GB')
                return < tr className='bg-blue-50' >
                  <td>{formattedDate}</td>
                  <td>{x.cn_ny_year}</td>
                  <td className='py-[1rem]'>
                    <button onClick={() => deleteCnyHandler(x._id)} style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem]  text-white'>
                      <RiDeleteBin6Line />
                      <p >Delete</p>
                    </button>
                  </td>
                </tr>
              }

              ) : 'CNY Year Not Set Yet'
            }

          </tbody>

        </table>

      </div>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />

    </div >
  )
}

export default CNYCheck